import React from 'react'
import SelectSubject from './SelectSubject/SelectSubject'
import SelectCompType from './SelectCompType/SelectCompType'
// import SelectDisplayAttr from './SelectDisplayAttr/SelectDisplayAttr'
import SelectRentCompView from './SelectRentCompView/SelectRentCompView'

const PropertyListSettings = () => {

    return (
        <>
            <div data-testid="test-div-Property-List-Settings" className="grid grid-cols-1 md:grid-cols-12 bg-gray-10">
                <div className="md:col-span-3 overflow-hidden ">

                </div>
                <div className="md:col-span-6 overflow-hidden mb-4 mx-4">
                    <div className="py-4">Settings</div>
                    <div className="flex flex-col space-y-4">
                        <div>
                            <SelectCompType />
                        </div>
                        <div>
                            <SelectSubject />
                        </div>
                        <div>
                            <SelectRentCompView />
                        </div>
                        {/* <div>
                            <SelectDisplayAttr />
                        </div> */}
                    </div>
                </div>
                <div className="md:col-span-3 overflow-hidden ">

                </div>
            </div>
        </>
    )
}

export default PropertyListSettings
